import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

// components
import BarGrouped from "app/static/frontend/widgets/components/visualization/BarGrouped"

// action creators
import { showInSearch } from "app/static/frontend/projects-new/list/action-creators"
import { segueToProfileWithId } from "global-action-creators"

// selectors
import { selectWidgetDataSources, selectWidgetQuorumDataType } from "app/static/frontend/widgets/selectors/selectors"

import {
    selectBarVisualizationData,
    selectBarVisualizationGroupKey,
    selectBarVisualizationIsHorizontal,
    selectBarVisualizationKeys,
} from "app/static/frontend/widgets/selectors/barVisualizationWidgetSelectors"

import { selectStancesWithCustomLabels } from "shared/stance/selectors"

const mapStateToProps = createStructuredSelector({
    data: selectBarVisualizationData,
    dataSources: selectWidgetDataSources,
    groupKey: selectBarVisualizationGroupKey,
    isHorizontal: selectBarVisualizationIsHorizontal,
    keys: selectBarVisualizationKeys,
    quorumDataType: selectWidgetQuorumDataType,
    stancesWithCustomLabels: selectStancesWithCustomLabels,
})

const mapDispatchToProps = {
    showInSearch,
    segueToProfileWithId,
}

export default connect(mapStateToProps, mapDispatchToProps)(BarGrouped)
